<!-- Admin Edit Article Text -->

<template>
	<div class="adm-edit-txt">
		<div class="lab-box">Category:</div>
		<CatPickBtn /> 

		<div class="v-spacer" />

		<div class="lab-box">Date:</div>
		<div class="pop-value-box" @click="popInput('dateCre')" v-html="convertLFs(rec.dateCre)"></div>

		<div class="v-spacer" />

		<div class="lab-box">Vis Date:</div>
		<div class="val-box">
			{{ rec.dateVis }}
		</div>

		<div class="v-spacer" />

		<div class="lab-box">Credit:</div>
		<div class="pop-value-box" @click="popInput('credit')" v-html="convertLFs(rec.credit)"></div>

		<div class="v-spacer" />

		<div class="lab-box">Title:</div>
		<div class="pop-value-box" @click="popInput('title')" v-html="convertLFs(rec.title)"></div>

		<div class="v-spacer" />

		<div class="lab-box">Story:</div><br />
		<div class="pop-value-box pop-textarea" @click="popInput('fullTxt')" v-html="convertLFs(rec.fullTxt)"></div>

		<div class="v-spacer" />

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import * as Utils from "@/utils/utils"
import { mapState } from 'vuex';
import { eventBus } from '@/main';

export default {
	data() {
		return {
			rec: {},
		};
	},
	computed: {
		...mapState('app',['current']),
	},
	methods: {
		popInput(colName) {
			Utils.showPopInput(colName, this.rec[colName]);
		},
		handleUpdateVal(payload) {
			let colName = payload.colName;
			let val = payload.val;
			this.rec[colName] = val;
			if(payload.colName=="dateCre") this.checkDate();		
		},
		convertLFs(str1="") {
			m("convert LFs", str1);
			let str2 = str1.replace(/\n/g, '<br/>', );
			return str2;
		},
		checkDate() {
			let d = this.uvaliDateStr(this.rec.dateCre);
			m('d',d);
			this.rec.dateCre = d.date;
			this.rec.dateVis = d.dateVis;
		},
		updateRec() {
			this.cat = this.current.cat;
			this.rec.catId = this.cat.itemId;
			this.rec.catItemId = this.cat.itemId;
			this.rec.catTitle = this.cat.title;
			// this.rec.title = document.getElementById("adm-edit-title").value;
			// this.rec.storyWhatever = document.getElementById("").value;
			const data = {
				step: "current",
				art: this.rec,
			};
			this.$store.dispatch("app/setArt", data);
		},
	},
	mounted() {
		m("adm edit txt mounted");
		this.rec = {...this.current.art};
		m("adm edit txt rec", this.rec);
	},
	created() {
		m("build created");
		eventBus.$on('update-value', this.handleUpdateVal);
	},
	beforeDestroy() {
		m("adm edit txt before destroy");
		this.updateRec();
		eventBus.$off('update-value', this.handleUpdateVal);
	},
}
</script>

<style scoped>

.adm-edit-txt {
	height: 100%;
	overflow-y: auto;
	border: solid 0px #C30;
}

.lab-box {
	display: inline-block;
	width: 80px;
	height: 22px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	border: solid 0px #369;
}


.pop-value-box {
	display: inline-block;
	width: 200px;
	height: 25px;
	overflow: hidden;
	vertical-align: top;
	cursor: pointer;
	background-color: #FFF;
	border: solid 1px #999;
}

.pop-textarea {
	height: 120px;
	width: 280px;
	overflow-x: none;
	overflow-y: auto;
}



.val-box {
	display: inline-block;
	width: 200px;
	height: 30px;
	overflow: hidden;
	vertical-align: top;
	white-space: nowrap;
	border: solid 0px #090;
}


.v-spacer {
	width: 10px;
	height: 4px;
	vertical-align: top;
	border: solid 0px #999;
}

input {
	width: 100%;
}

.OLDtextarea {
	width: 100%;
	height: 100%;
	overflow-y: auto;
	resize: none;
}

</style>
